module.exports = __webpack_public_path__ + "static/img/ent-53.f4126f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-53.jpg
// module id = 4rNN
// module chunks = 52